import type { ComponentType } from 'react';
import type { QuestionType } from '../core/schema/question-types.ts';
import {
  MatchingRenderer,
  MultipleChoiceRenderer,
  OrderingRenderer,
  SingleChoiceRenderer,
  TextRenderer,
} from './renderers.tsx';
import type { RendererProps } from './shared/QuestionParts.tsx';

/**
 * One renderer per question type.
 *
 * `Record<QuestionType, …>` on purpose: adding a type to the format breaks the build here until it
 * has a renderer, the same guard rail the scoring registry uses. Between the two, a new question
 * type cannot reach a user half-implemented.
 *
 * This is also the seam a plugin architecture would use later (V2): everything the application
 * knows about how a question is answered arrives through this map.
 */
export const QUESTION_RENDERERS: Record<QuestionType, ComponentType<RendererProps>> = {
  'single-choice': SingleChoiceRenderer,
  'multiple-choice': MultipleChoiceRenderer,
  matching: MatchingRenderer,
  ordering: OrderingRenderer,
  text: TextRenderer,
};

export type { RendererProps };
